import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import grantService from '../services/grantService';
import './GrantDetailsPage.css';

const GrantDetailsPage = () => {
  const { grantId } = useParams();
  const [grant, setGrant] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchGrantDetails = async () => {
      try {
        setLoading(true);
        const response = await grantService.getGrantDetails(grantId);
        setGrant(response.data);
        setError(null);
      } catch (error) {
        console.error('Error fetching grant details:', error);
        setError('Failed to load grant details. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchGrantDetails();
  }, [grantId]);

  if (loading) {
    return <div className="loading">Loading grant details...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  if (!grant) {
    return <div className="error-message">Grant not found</div>;
  }

  return (
    <div className="grant-details">
      <Link to="/" className="back-link">← Back to Search</Link>

      <div className="card">
        <h1>{grant.ProjectTitle}</h1>

        <div className="grant-meta">
          <div className="meta-item">
            <strong>Grant ID:</strong> {grant.GrantID}
          </div>
          <div className="meta-item">
            <strong>Fiscal Year:</strong> {grant.FiscalYear}
          </div>
          <div className="meta-item">
            <strong>Agency/Department:</strong> {grant.AgencyDept}
          </div>
        </div>

        <div className="section">
          <h2>Recipient Information</h2>
          <div className="info-grid">
            <div className="info-item">
              <strong>Recipient Name:</strong>
              <p>{grant.RecipientName}</p>
            </div>
            <div className="info-item">
              <strong>Recipient Type:</strong>
              <p>{grant.RecipientType}</p>
            </div>
          </div>
        </div>

        <div className="section">
          <h2>Award Information</h2>
          <div className="info-grid">
            <div className="info-item">
              <strong>Total Award Amount:</strong>
              <p>{grantService.formatCurrency(grant.TotalAwardAmount)}</p>
            </div>
            <div className="info-item">
              <strong>Matching Funding Amount:</strong>
              <p>{grant.MatchingFundingAmount ? grantService.formatCurrency(grant.MatchingFundingAmount) : 'N/A'}</p>
            </div>
            <div className="info-item">
              <strong>Project Start Date:</strong>
              <p>{grant.ProjectStartDate || 'N/A'}</p>
            </div>
            <div className="info-item">
              <strong>Project End Date:</strong>
              <p>{grant.ProjectEndDate || 'N/A'}</p>
            </div>
            <div className="info-item">
              <strong>Project Status:</strong>
              <p>{grant.ProjectStatus || 'N/A'}</p>
            </div>
          </div>
        </div>

        {grant.ProjectAbstract && (
          <div className="section">
            <h2>Project Abstract</h2>
            <p>{grant.ProjectAbstract}</p>
          </div>
        )}

        <div className="section">
          <h2>Geographic Information</h2>
          <div className="info-grid">
            <div className="info-item">
              <strong>Location Served:</strong>
              <p>{grant.GeographicLocationServed || 'N/A'}</p>
            </div>
            <div className="info-item">
              <strong>Counties Served:</strong>
              <p>{grant.CountiesServed || 'N/A'}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GrantDetailsPage;